import React from 'react'
import PropTypes from 'prop-types'
import LimitTable from "./FooterTable/LimitTable"
import PaginationTable from "./FooterTable/PaginationTable"

class ListItemsFooter extends React.Component {
    parsePagination = () => {
        const {pagination} = this.props
        const {page, limit: limitProps, total: totalProps} = pagination
        const total = totalProps > 0 ? totalProps : 0
        const limit = limitProps > 0 ? limitProps : 0
        const totalPages = limit && Math.ceil(total / limit)

        return {page, limit, total: totalPages}
    }

    render() {
        const pagination = this.parsePagination()
        const {prev, next, loading, filter, onChangePagination, onChangeFilter, onChangePreCurrentPage, onChangeNextCurrentPage, currentPage} = this.props

        return (
            <div className='ListItemsFooter'>
                <div className='DataTableFooter header-elements-inline py-3'>
                    <LimitTable loading={loading} limit={pagination.limit} onChangePagination={onChangePagination}/>
                    <PaginationTable 
                        filter={filter} 
                        loading={loading} 
                        next={next} 
                        prev={prev}
                        onChangeFilter={onChangeFilter}
                        currentPage={currentPage}
                        onChangeNextCurrentPage={onChangeNextCurrentPage}
                        onChangePreCurrentPage={onChangePreCurrentPage}
                    />
                </div>
            </div>
        )
    }
}

ListItemsFooter.propTypes = {
    filter: PropTypes.object.isRequired,
    next: PropTypes.string,
    prev: PropTypes.string,
    loading: PropTypes.bool,
    pagination: PropTypes.object.isRequired,
    onChangePagination: PropTypes.func.isRequired,
    onChangeFilter: PropTypes.func.isRequired
}

export default ListItemsFooter
